// extracted by mini-css-extract-plugin
export default {"metadata":"taskSheet_metadata__qEZMR"};